import Vue from 'vue'
import App from './App.vue'
import router from './router/global'
import store from './store/global'
import utils from './utils/utils'
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'

Vue.config.productionTip = false

Vue.use(Antd)

Vue.prototype.utils = utils

router.afterEach(() => {
  window.scrollTo(0,0);
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
